import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppState, RolLogin, UserActions, UserLogin, UserLoginEmptyState } from "ngx-sds-login";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";


@Component({
  selector: "app-accent",
  templateUrl: "./acceso.component.html",
  styleUrls: ["./acceso.component.scss"],
})
export class AccesoComponent implements OnInit {

  roles: RolLogin[] = [];
  user$: Observable<UserLogin>;
  newUser: UserLogin;

  constructor(
    private router: Router,
    private store: Store<AppState>,
  ) {
    this.newUser = UserLoginEmptyState;
    this.user$ = this.store.select(state => state.user);
    this.user$.subscribe(user => {
      this.roles = user.roles;
      this.newUser = user;
      //debugger;
      if (this.roles.length === 1 && user.rolId !== this.roles[0].id) {
        this.redirectUser(this.roles[0].vcCodigoInterno, this.roles[0].id);
      }
    });
  }

  ngOnInit(): void {
    if (this.roles && this.roles.length === 1) this.redirectUser(this.roles[0].vcCodigoInterno, this.roles[0].id);
  }

  redirectUser(rol: string, id: number) {

    const updatedUser = { ...this.newUser, rolId: id };
    this.store.dispatch(UserActions.modifyUser({payload: updatedUser}));

    let dir: string;

    switch (rol) {
      case 'ROL_REFERENTE':
        dir = 'card_referente';
        break;

      case 'ROL_DIRECTIVO':
        dir = 'card_directivo'
        break;

      case 'ROL_PROGRAMADOR':
        dir = 'card_programador'
        break;

      default:
        return;
    }

    this.router.navigate([`/${dir}`]);
  }
}
